import { ADD_NOTIFY, DELETE_NOTIFY, GET_NOTIFY, UPDATE_NOTIFY } from "../types";

const initialState = { list: [], single: null };

const reducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case GET_NOTIFY:
            return { ...state, list: payload };

        case ADD_NOTIFY:
            return {
                ...state,
                list: [payload, ...state.list],
            };

        case UPDATE_NOTIFY:
            return {
                ...state,
                list: state.list.map((item) =>
                    item.id === payload._id ? payload : item
                ),
            };

        case DELETE_NOTIFY:
            return {
                ...state,
                list: state.list.filter((item) => item._id !== payload._id),
            };

        default:
            return state;
    }
};

export default reducer;
